import React, { ReactNode } from "react";
import useStyles from "../../components/common/model/styles";
import Popup from "../../components/common/model/Popup";
import { Alert } from "@mui/material";
import closeIcon from "../../assets/closeModel.png";
import CustomButton from "../../components/common/button/CustomButton";
import { useDispatch } from "react-redux";

import Notification from "../../components/common/notification/Notification";
import { setNotificationAction } from "../../store/reducers/mmymSlice";

interface DeleteAlertPopupProps {
  title?: string;
  open?: boolean;
  onHide?: () => void;
  alertModalShow?: any;
  setAlertModelShow?: (show: boolean) => void;
  onConfirm?: () => void;
  message?: string;
  children?: ReactNode;
  confirmDisabled?: boolean;
}
const DeleteAlert: React.FC<DeleteAlertPopupProps> = ({
  onHide,
  title,
  alertModalShow,
  setAlertModelShow,
  onConfirm,
  message,
  children,
  confirmDisabled = false,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const submitHandler = () => {
    if (onConfirm) {
      onConfirm(); // <-- call parent function
    }
  };
  const closeModel = () => {
    if (setAlertModelShow) {
      setAlertModelShow(false);
    }
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <Popup
      open={alertModalShow}
      title={title || "Alert"}
      onHide={closeModel}
      fullWidth={true}
      maxWidth={"sm"}
      disableContentText
      aria-describedby="alert-dialog-slide-description"
      header={
        <>
          <img
            onClick={closeModel}
            src={closeIcon}
            className={classes.closeicons}
            alt="close"
          />
        </>
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={closeModel} />
          <CustomButton
            title="Yes"
            onClick={submitHandler}
            disabled={confirmDisabled}
          />
        </>
      }
    >
      <>
        <Notification />
        {children}
        <Alert
          sx={{
            bgcolor: "#eeecef",
            fontSize: "16px",
            alignItems: "flex-start",
            "& .MuiAlert-message": {
              width: "100%",
              overflowWrap: "anywhere",
              whiteSpace: "normal",
            },
          }}
          severity="warning"
        >
          {message}
        </Alert>
      </>
    </Popup>
  );
};

export default DeleteAlert;
